(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article-guide"]) return;
  try {
    
  if (!customElements.get('article-guide')) {
    customElements.define('article-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';

        const prose = this.querySelector('[data-guide-prose]');
        const rail = this.querySelector('[data-guide-rail]');
        const layout = this.querySelector('.article-guide__layout');
        const picks = [...this.querySelectorAll('[data-guide-pick]')];
        const expand = this.querySelector('[data-guide-expand]');
        const dockQuery = window.matchMedia('(max-width: 1099px)');

        const syncDockHeight = () => {
          if (!layout) return;
          const dockOpen = dockQuery.matches && rail && rail.classList.contains('article-guide__rail--shoppable') && !rail.classList.contains('is-hidden');
          layout.style.setProperty('--article-guide-dock-height', dockOpen ? `${rail.offsetHeight}px` : '0px');
        };

        expand?.addEventListener('click', () => {
          const open = rail.classList.toggle('is-expanded');
          expand.setAttribute('aria-expanded', open ? 'true' : 'false');
          expand.textContent = open ? expand.dataset.labelCollapse : expand.dataset.labelExpand;
          syncDockHeight();
        });

        if (rail && rail.classList.contains('article-guide__rail--shoppable')) {
          const section = this.closest('.shopify-section');
          if (section) {
            const visibility = new IntersectionObserver((entries) => {
              rail.classList.toggle('is-hidden', !entries.some((entry) => entry.isIntersecting));
              syncDockHeight();
            });
            visibility.observe(section);
          }
          if (window.ResizeObserver) {
            const resize = new ResizeObserver(syncDockHeight);
            resize.observe(rail);
          }
          dockQuery.addEventListener('change', syncDockHeight);
          syncDockHeight();
        }

        if (!prose) return;

        prose.addEventListener('change', (event) => {
          const select = event.target;
          if (!(select instanceof HTMLSelectElement) || select.name !== 'id' || !select.closest('.article-inline-product')) return;
          const option = select.selectedOptions[0];
          const card = select.closest('.article-inline-product');
          if (!option || !card) return;

          const label = card.querySelector('[data-article-variant-label]');
          if (label) label.textContent = option.dataset.title || option.text;

          const image = card.querySelector('.product-gallery__media img');
          if (image && option.dataset.image) {
            image.src = option.dataset.image;
            image.removeAttribute('srcset');
          }

          const salePrice = card.querySelector('sale-price');
          if (salePrice && option.dataset.price) {
            const hiddenLabel = salePrice.querySelector('.sr-only');
            salePrice.textContent = option.dataset.price;
            if (hiddenLabel) salePrice.prepend(hiddenLabel);
          }

          card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
            const url = new URL(link.getAttribute('href'), window.location.origin);
            url.searchParams.set('variant', option.value);
            link.setAttribute('href', `${url.pathname}${url.search}`);
          });
        });

        const normalize = (value) => (value || '')
          .toLowerCase()
          .replace(/^\s*\d+[.)]\s*/, '')
          .replace(/&amp;/g, '&')
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();

        const headings = [...prose.querySelectorAll('h2')];
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `guide-section-${index + 1}`;
          const link = this.querySelector(`[data-guide-toc-index="${index + 1}"]`);
          if (link) link.setAttribute('href', `#${heading.id}`);
        });

        const matchHandle = (heading) => {
          const headingText = normalize(heading.textContent);
          for (const pick of picks) {
            const title = normalize(pick.dataset.productTitle);
            if (title.length > 3 && headingText.includes(title)) return pick.dataset.productHandle;
          }

          const parts = [];
          let node = heading;
          while (node) {
            if (node !== heading && node.nodeType === 1 && node.tagName === 'H2') break;
            if (node.nodeType === 1) parts.push(node);
            node = node.nextSibling;
          }
          const html = parts.map((element) => element.outerHTML || '').join(' ').toLowerCase();
          for (const pick of picks) {
            const handle = (pick.dataset.productHandle || '').toLowerCase();
            if (handle && html.includes(`/products/${handle}`)) return handle;
          }
          return '';
        };

        const activate = (handle) => {
          if (!handle) return;
          picks.forEach((pick) => {
            pick.classList.toggle('is-active', pick.dataset.productHandle === handle);
          });
        };

        if (!headings.length || !picks.length) return;

        const matches = headings.map((heading) => matchHandle(heading));
        const observer = new IntersectionObserver((entries) => {
          const visible = entries.filter((entry) => entry.isIntersecting);
          if (!visible.length) return;
          const current = visible[visible.length - 1];
          const index = headings.indexOf(current.target);
          if (index >= 0) activate(matches[index]);
        }, { rootMargin: '-12% 0px -55% 0px', threshold: [0, 1] });

        headings.forEach((heading) => observer.observe(heading));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
